<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12" class="mb-3">
          <b-button variant="primary" @click="$router.go(-1)" class="pull-left back-btn">Terug</b-button>
        </b-col>
        <b-col cols="12">
          <b-card no-body>
            <template v-slot:header>
              <span class="pull-left mt-2 mb-2"><strong>Account: {{item.name}}</strong></span>
            </template>
            <b-col cols="12" class="mt-2">
              <b-form-group label="Naam">
                <b-form-input type="text" required v-model="item.name" disabled></b-form-input>
              </b-form-group>
              <b-form-group label="Recordtype">
                <b-form-input type="text" required v-model="item.type" disabled></b-form-input>
              </b-form-group>
              <b-form-group label="E-mailadres">
                <b-form-input type="text" required v-model="item.email" disabled></b-form-input>
              </b-form-group>
              <b-form-group label="E-mail aanhef">
                <b-form-input type="text" required v-model="item.email_salutation" disabled></b-form-input>
              </b-form-group>
              <div v-if="item.childs.length > 0">
                <p><strong>Dochter accounts</strong></p>
                <ul>
                  <li v-for="company in item.childs">
                    <a class="hoverable" :href="'/admin/accounts/'+company.id">{{company.name}}</a>
                  </li>
                </ul>
              </div>
              <div v-if="item.mother !== null">
                <p><strong>Moeder account</strong></p>
                <ul>
                  <li><a class="hoverable" :href="'/admin/accounts/'+item.mother.id">{{item.mother.name}}</a></li>
                </ul>
              </div>
            </b-col>
          </b-card>
        </b-col>
        <b-col cols="12">
          <b-card header="Participaties" no-body>
            <b-col>
              <account-participations :participations="item.participations"/>
            </b-col>
          </b-card>
        </b-col>
        <b-col cols="12">
          <b-card header="Uitkeringen" no-body>
            <b-col>
              <account-benefits :benefits="item.benefits"/>
            </b-col>
          </b-card>
        </b-col>
        <b-col cols="12">
          <b-card header="Contactpersonen" no-body>
            <b-col>
              <account-contacts :contacts="item.contacts"/>
            </b-col>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import {getData} from '../../api';
import AccountParticipations from "@/views/accounts/parts/Participations";
import AccountBenefits from "@/views/accounts/parts/Benefits";
import AccountContacts from "@/views/accounts/parts/Contacts";

export default {
  name: 'account',
  components: {AccountContacts, AccountBenefits, AccountParticipations},
  props: ['id'],
  data() {
    return {
      saveButtonDisabled: false,
      feedback: {
        show: false,
        text: '',
        variant: null,
        dismissCountDown: 4
      },
      contacts: [],
      editable: false,
      companyOptions: [],
      countryOptions: [],
      item: [],
      errors: null,
    }
  },
  methods: {
    async getItem() {
      const item = await getData('accounts/' + this.$route.params.id).then(response => response.data);
      this.item = item.data
    }
  },
  beforeMount() {
    this.getItem();
  },
}

</script>
